<div fxLayout="row" fxLayoutAlign="center">
  <div fxFlex="0 1 auto">
    <p-panel>
      <p-header>
        <h2>Reset password</h2>
      </p-header>
      <form name="form" [formGroup]="form" (ngSubmit)="resetPassword()">
        <div class="form-group">
          <label>Password</label>
          <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
          @if (submitted && f.password.errors) {
            <div class="invalid-feedback">
              @if (f.password.errors.required) {
                <div>Password is required</div>
              }
              @if (f.password.errors.minlength) {
                <div>Password must be at least 6 characters</div>
              }
            </div>
          }
        </div>
        <div class="form-group">
          <label>Confirm Password</label>
          <input type="password" formControlName="cpassword" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.cpassword.errors }" />
          @if (submitted && f.cpassword.errors) {
            <div class="invalid-feedback">
              @if (f.cpassword.errors.required) {
                <div>Confirm Password is required</div>
              }
              @if (f.cpassword.errors.mustMatch) {
                <div>Passwords must match</div>
              }
            </div>
          }
        </div>
        <div class="form-group">
          <button [disabled]="loading" class="btn btn-primary">Reset</button>
          @if (loading) {
<img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
}
		        </div>
		        @if (error) {
<div class="alert alert-danger">{{error}}</div>
}
		        @if (requestMsg) {
<div>{{requestMsg}}<br><a [routerLink]="['/login']">Back to login</a></div>
}
		    </form>
		</p-panel>
    </div>
</div>    